/* unplugin-vue-components disabled */import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "left_captions_area"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "row"
};
const _hoisted_4 = {
  class: "row"
};
const _hoisted_5 = {
  class: "row"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "row"
};
const _hoisted_8 = {
  key: 1,
  style: {
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_9 = {
  key: 2,
  style: {
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_10 = {
  key: 0,
  class: "right_captions_area"
};
const _hoisted_11 = {
  key: 0,
  class: "right_captions_area_list"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0,
  class: "row"
};
import VideoCard from "@/components/Card/VideoCard/index.vue";
import Player from "@/components/jessibuca/index.vue";
import XiGuaPlayer from "@/components/XGPlayer/xgPlayer.vue";
import TextCard from "@/components/Card/TextCard/index.vue";
import screenfull from "screenfull";
import usePermissionStore from "@/store/modules/permission";
export default {
  __name: 'pop',
  props: {
    // 是否显示提示
    isTasking: {
      type: Boolean,
      default: true
    }
  },
  setup(__props, {
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const pageData = inject("pageData");
    const recentlyTaskId = inject("recentlyTaskId");
    const handleChildEvent = inject("handleChildEvent");
    const handleChildEventTimeBack = inject("handleChildEventTimeBack");
    const switchVideo = inject("switchVideo");
    const emit = __emit;
    const permission = usePermissionStore();
    const props = __props;
    const showSubtitle = ref(false);
    const fullscreen = ref(false);
    const videoStartRecord = ref(false);
    const aspectRatioState = ref(false);
    const downloadProgressFormat = percentage => {
      return percentage === 100 ? '已完成' : `下载中`;
    };
    function onPodVideoCardSwitchChange() {
      showSubtitle.value = !showSubtitle.value;
    }
    function downloadMp4(a, b) {
      emit("downloadMp4", a, b);
    }
    function onPodVideoCardFullScreenClick() {
      if (proxy.$refs["podVideoRef"] === undefined) {
        return;
      }
      setTimeout(() => {
        requestAnimationFrame(() => {
          const dom = document.getElementsByClassName("pod_video_card")[0];
          if (fullscreen.value) {
            screenfull.exit();
            fullscreen.value = false;
            proxy.$refs["podVideoRef"].setJessibucaStyle(false);
          } else {
            screenfull.request(dom);
            fullscreen.value = true;
            proxy.$refs["podVideoRef"].setJessibucaStyle(true);
          }
        });
      }, 50);
    }
    function onPodVideoCardVideoClick() {
      if (proxy.$refs["podVideoRef"] === undefined) {
        return;
      }
      if (videoStartRecord.value) {
        proxy.$refs["podVideoRef"].videoStopRecordAndSave();
        videoStartRecord.value = false;
      } else {
        proxy.$refs["podVideoRef"].videoStartRecord();
        videoStartRecord.value = true;
        proxy.$modal.msgWarning("开始录屏，再次点击结束录屏");
      }
    }
    function onPodVideoCardScreenCutClick() {
      if (proxy.$refs["podVideoRef"] === undefined) {
        return;
      }
      proxy.$refs["podVideoRef"].videoScreenShot();
    }
    function onPodVideoCardReduction() {
      if (proxy.$refs["podVideoRef"] === undefined) {
        return;
      }
      aspectRatioState.value = !aspectRatioState.value;
      proxy.$refs["podVideoRef"].setJessibucaStyle(aspectRatioState.value);
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_progress = _resolveComponent("el-progress");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      return _openBlock(), _createBlock(VideoCard, {
        ref: "podVideoCardRef",
        "show-subtitle": _unref(showSubtitle),
        "show-switch": __props.isTasking,
        "show-full-screen": __props.isTasking,
        "show-video-camera": __props.isTasking,
        "show-picture-outlined": __props.isTasking,
        "show-aspect-ratio": __props.isTasking,
        "controlel-size": "small",
        "aspect-ratio-state": _unref(aspectRatioState),
        onSwitchChange: onPodVideoCardSwitchChange,
        onFullScreenClick: onPodVideoCardFullScreenClick,
        onVideoClick: onPodVideoCardVideoClick,
        onScreenCutClick: onPodVideoCardScreenCutClick,
        onReduction: onPodVideoCardReduction,
        class: "pod_video_card"
      }, {
        default: _withCtx(() => [_unref(showSubtitle) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, "俯仰角度: " + _toDisplayString(), 1), _createElementVNode("div", _hoisted_3, "目标高度: " + _toDisplayString(), 1), _createElementVNode("div", _hoisted_4, "图像跟踪状态: " + _toDisplayString(), 1), _createElementVNode("div", _hoisted_5, "目标经度: " + _toDisplayString(), 1), _createElementVNode("div", _hoisted_6, "目标纬度: " + _toDisplayString(), 1), _createElementVNode("div", _hoisted_7, "方位角度: " + _toDisplayString(), 1)])) : _createCommentVNode("", true), _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "box-name"
        }, null, -1)), _unref(pageData).deviceVideo.podUrl !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(Player, {
          ref: "podVideoRef",
          url: _unref(pageData).deviceVideo.podUrl,
          "flv-url": _unref(pageData).deviceVideo.podFlvUrl,
          fluent: "",
          autoplay: ""
        }, null, 8, ["url", "flv-url"])])) : _createCommentVNode("", true), _unref(pageData).recordVideo.podUrl !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_unref(pageData).recordVideo.podList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = $event => _unref(pageData).recordListShow.one = !_unref(pageData).recordListShow.one),
          class: "row"
        }, [_createVNode(_component_el_button, {
          style: {
            "width": "10.1rem"
          },
          size: "small"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("录像列表", -1)]))]),
          _: 1
        })]), _unref(pageData).recordListShow.one ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).recordVideo.podList, (podInfo, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "row",
            key: index,
            onClick: $event => _unref(switchVideo)(index, 1)
          }, [podInfo.liveRecordStartTime === _unref(pageData).recordVideo.podIndex ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: "small",
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(podInfo.liveRecordStartTime) + "—" + _toDisplayString(podInfo.liveRecordStopTime), 1)]),
            _: 2
          }, 1024)) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            size: "small",
            type: "info"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(podInfo.liveRecordStartTime) + "—" + _toDisplayString(podInfo.liveRecordStopTime), 1)]),
            _: 2
          }, 1024))], 8, _hoisted_12);
        }), 128))])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("div", null, [_unref(permission).downloadMp4.indexOf(_unref(pageData).recentlyTaskInfo.taskName + 'pod') > -1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_progress, {
          style: {
            "margin-left": "-0.6rem",
            "color": "#0d0d0d"
          },
          indeterminate: true,
          "text-inside": true,
          format: downloadProgressFormat,
          "stroke-width": 24,
          percentage: _unref(pageData).downloadProgressPercentage,
          status: "success"
        }, null, 8, ["percentage"])])) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = $event => downloadMp4(_unref(recentlyTaskId), 'pod')),
          class: "row"
        }, [_createVNode(_component_el_button, {
          style: {
            "width": "10.1rem"
          },
          size: "small"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("录像下载", -1)]))]),
          _: 1
        })]))])), [[_directive_hasPermi, ['drone:task:download']]])])) : _createCommentVNode("", true), _createVNode(XiGuaPlayer, {
          ref: "podVideoRec",
          onReportedFlightData: _unref(handleChildEvent),
          onReportedTime: _unref(handleChildEventTimeBack),
          id: 'app1',
          "video-index": _unref(pageData).recordVideo.podId,
          "video-url": _unref(pageData).recordVideo.podUrl,
          "start-time": _unref(pageData).recordVideo.podPlayTime,
          "web-vtt": _unref(pageData).recordVideo.webVtt
        }, null, 8, ["onReportedFlightData", "onReportedTime", "video-index", "video-url", "start-time", "web-vtt"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["show-subtitle", "show-switch", "show-full-screen", "show-video-camera", "show-picture-outlined", "show-aspect-ratio", "aspect-ratio-state"]);
    };
  }
};